var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkilllevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.996,
    height: 49,
    viewBox: "0 0 48.996 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-798.352 -1462.518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.894,1525.342a11.08,11.08,0,0,1-1.979-.88,4.2,4.2,0,0,1-1.369-5.191,4.3,4.3,0,1,1,4.811,5.976c-.107.023-.21.063-.314.095Z",
    transform: "translate(-8.875 -13.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.136,1522.395a1.836,1.836,0,0,1-1.927,1.066c-3.061-.036-6.123-.013-9.184-.013h-.52v-2.871h.473c3.077,0,6.154.022,9.231-.013a1.835,1.835,0,0,1,1.927,1.066Z",
    transform: "translate(-12.788 -14.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.576,1481.283v-17.027c0-1.213.53-1.737,1.752-1.737q2.631,0,5.261,0a1.453,1.453,0,0,1,1.6,1.6q0,17.146,0,34.293a1.463,1.463,0,0,1-1.633,1.617q-2.678,0-5.356,0a1.462,1.462,0,0,1-1.621-1.629Q848.575,1489.844,848.576,1481.283Z",
    transform: "translate(-12.806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.776,1486.325q0,7.006,0,14.012c0,1.188-.536,1.727-1.715,1.728q-2.63,0-5.26,0a1.464,1.464,0,0,1-1.636-1.614q0-14.18,0-28.36a1.453,1.453,0,0,1,1.594-1.606q2.7-.005,5.4,0a1.463,1.463,0,0,1,1.613,1.637Q841.777,1479.223,841.776,1486.325Z",
    transform: "translate(-8.876 -2.031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.751,1491.062q0-5.594,0-11.189a1.476,1.476,0,0,1,1.664-1.681q2.654,0,5.308,0a1.469,1.469,0,0,1,1.639,1.658q0,11.261,0,22.523a1.47,1.47,0,0,1-1.64,1.658q-2.678,0-5.355,0a1.463,1.463,0,0,1-1.615-1.635Q817.749,1496.728,817.751,1491.062Z",
    transform: "translate(-4.946 -3.996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.951,1495.949q0,4.183,0,8.367a1.477,1.477,0,0,1-1.667,1.678q-2.653,0-5.307,0a1.47,1.47,0,0,1-1.638-1.659q0-8.392,0-16.783a1.468,1.468,0,0,1,1.642-1.654q2.678,0,5.354,0a1.463,1.463,0,0,1,1.615,1.635Q810.953,1491.741,810.951,1495.949Z",
    transform: "translate(-1.016 -5.961)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.469,1520.58v2.871h-.4q-10.545,0-21.09,0a1.444,1.444,0,0,1-1.517-1.95,1.408,1.408,0,0,1,1.237-.916,3.437,3.437,0,0,1,.382-.005h21.39Z",
    transform: "translate(0 -14.804)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkilllevel);
export default __webpack_public_path__ + "static/media/Skilllevel.3e4290b8.svg";
export { ForwardRef as ReactComponent };